(function () {
  function start_geolizr_geo_access() {
    if (!window.geo_access_popup) {
      return;
    }

    window.geo_access_popup.start(function (config, handle_country_code) {
      var buffered_data = window.geo_access_geolizr_data;

      if (buffered_data) {
        handle_country_code(get_country_code(buffered_data));
        return;
      }

      document.addEventListener('geolizr.geoData', function (event) {
        handle_country_code(get_country_code(event));
      });
    });
  }

  function get_country_code(event) {
    var geo_data = event.detail || event.geoData || event;

    if (!geo_data) {
      return '';
    }

    if (geo_data.countryCode) {
      return geo_data.countryCode;
    }

    if (geo_data.country && geo_data.country.code) {
      return geo_data.country.code;
    }

    return '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start_geolizr_geo_access);
  } else {
    start_geolizr_geo_access();
  }

  document.addEventListener('shopify:section:load', start_geolizr_geo_access);
})();
